import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Http } from '@angular/http';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { Broker, BrokerSubscriber, Platform, Storage } from '@c4/core';
import { C4InputConfig, UIModule } from '@c4/ui';

import { SysmanComponentBase, IOnBrokerConnectedInit } from '../sysman/sysman.component';
import { ListSelectorComponent } from '../list-selector/list-selector';
import { ConnectedDeviceService, DiscoveryService, CustomDeviceService, NetworkService, VersionsService } from '../services';

@Component({
  selector: 'sysman-sddp-discovery',
  templateUrl: './sysman-sddp-discovery.component.html',
  styleUrls: ['./sysman-sddp-discovery.component.less']
})
export class SysmanSddpDiscoveryComponent extends SysmanComponentBase implements OnInit, IOnBrokerConnectedInit {

  discoveredDevices: Array<any>;
  directorsFound: Array<any>;
  customDevices: Array<any>;
  allDevices: Array<any>;
  allVersions: string;
  nodemod: string;
  sortByField: string;
  sortOrder: string;
  addDeviceName: string;
  addDeviceAddress: string;
  errorMessage: string = "";
  showInvalidIPAddress: boolean;

  showAddDeviceModal = false;

  // C4-input format
  inputConfig: C4InputConfig = {
    layout: 'horizontal',
    labelColumns: 3
  }

  constructor(private store: Store<any>, private router: Router, private route: ActivatedRoute, private httpService: Http,
    private broker: Broker, private storage: Storage, private platform: Platform,
    private connectedDeviceService: ConnectedDeviceService, private discoService: DiscoveryService,
    private networkService: NetworkService,
    private customDeviceService: CustomDeviceService, private versionsService: VersionsService) {
    super(router, route, store, broker, platform, connectedDeviceService, versionsService);
    super.setBrokerInit(this.onBrokerConnectedInit); // method to call on broker init

    this.customDevices = [];
    this.discoveredDevices = [];
    this.directorsFound = [];
    this.allDevices = [];
    this.allVersions = "";
    this.nodemod = "";
    this.sortByField = "name";
    this.sortOrder = "desc";
    this.showInvalidIPAddress = false;
    this.addDeviceName = "";
    this.addDeviceAddress = "";
    this.errorMessage = "";

    // get custom user added devices from service
    this.subscriptions.push(
      this.store.select(s => s.customDevices).subscribe(
        d => {
          console.log('SysmanSddpDiscoveryComponent: customDevices', d);
          if (d && d.customDevices && Array.isArray(d.customDevices.devices) && (d.customDevices.devices.length > 0)) {
            this.customDevices = d.customDevices.devices;
            this.sortBy(this.sortByField, this.sortOrder);
            this.customDevices.forEach(o => {
                  this.versionsService.getAllVersions(o.address).then(
                    (data: any) => {
                      let version = data["system-version"];
                      let findItems = this.customDevices.filter(item => {
                        return (item.address == o.address);
                      });
                      if (findItems.length > 0)
                        findItems[0].version = version;
                    },
                    (err: any) => { }
                  );
            });
          }
          else {
            this.allDevices = this.discoveredDevices;
          }
        }));

    // get SDDP device from service
    this.subscriptions.push(
      this.store.select(s => s.discoveredDevices).subscribe(
        discoDevices => {
          //console.log('in discoDevices', discoDevices);
          if (discoDevices) {
            // shouldn't be an array
            if (discoDevices.discoveredDevices && (!Array.isArray(discoDevices.discoveredDevices.devices))) {
              var dupes = this.discoveredDevices.filter(item => {
                return (item.address == discoDevices.discoveredDevices.devices.address);
              });
              if ((dupes.length == 0) &&
                (discoDevices.discoveredDevices.devices.ST) &&
                (discoDevices.discoveredDevices.devices.ST.indexOf("c4:director") == 0)) {
                this.directorsFound.push(discoDevices.discoveredDevices.devices.address);
                this.updateDirectors(discoDevices.discoveredDevices.devices.address);
              }
              if ((dupes.length == 0) &&
                (discoDevices.discoveredDevices.devices.ST) &&
                (discoDevices.discoveredDevices.devices.ST.indexOf("c4:sysman") == 0)) {

                // trim c4:sysman head from name
                discoDevices.discoveredDevices.devices.USN = discoDevices.discoveredDevices.devices.USN.substring("c4:sysman-".length);
                this.discoveredDevices.push(discoDevices.discoveredDevices.devices);
                // default sort by USN
                this.sortBy(this.sortByField, this.sortOrder);
                this.updateDirectors(discoDevices.discoveredDevices.devices.address);

                // for each SDDP controller found...
                // fire off msg to get director version from platform_status
                let thisDevice = discoDevices.discoveredDevices.devices;
                this.versionsService.getAllVersions(thisDevice.address).then(
                  (data: any) => {
                    let version = data["system-version"];
                    let findItems = this.discoveredDevices.filter(item => {
                      return (item.address == thisDevice.address);
                    });
                    if (findItems.length > 0)
                      findItems[0].version = version;
                  },
                  (err: any) => { }
                );
              }
            }
          }
        }));
  }

  ngOnInit() {
    super.OnInit();
    this.discoveredDevices = [];
    this.directorsFound = [];

    console.debug('SysmanSddpDiscoveryComponent: ngOnInit()');
    this.connectedDeviceService.setWorking(true);

    // start subscription to local storage devices
    this.customDeviceService.getCustomDevices();
  }

  onBrokerConnectedInit() {
    this.discoService.startDiscovery();
  }

  ngOnDestroy() {
    console.debug('SysmanSddpDiscoveryComponent: onNgDestroy()');
    super.destroy();
    this.discoveredDevices = [];
    this.customDevices = [];
    this.allDevices = [];
    this.discoService.stopDiscovery();
    this.showInvalidIPAddress = false;
    this.addDeviceName = "";
    this.addDeviceAddress = "";
  }

  private deviceSelected(device: any) {
    console.debug('SysmanSddpDiscoveryComponent: deviceSelected()', device);
    device.errorMessage = "";
    this.errorMessage = "";
    // check for speaker points, no longer supported
    if (device.USN && (device.USN.indexOf("speaker-point") > -1)) {
      device.errorMessage = "Speaker Point is not supported. Use Windows System Manager to configure.";
      this.errorMessage = device.errorMessage; 
      return;
    }
    this.connectedDeviceService.setWorking(true);

    // check if device is available and running sysman
    this.networkService.getSysmanInfo(device.address).then(
      (data: any) => {
        this.connectedDeviceService.setWorking(false);
        this.connectedDeviceService.setConnection({ address: device.address, uuid: device.USN, version: device.version, directorName: "" });

        this.router.navigate(['../../sysman/details'], { relativeTo: this.route });
        // get director version and name
        this.httpService.get("https://" + device.address + "/api/v1/platform_status")
          .map(res => res.json())
          .subscribe(platformStatus => {
            let directorVersion = this.getDirectorVersion(platformStatus);
            this.connectedDeviceService.setConnection({ address: device.address, uuid: platformStatus.directorUUID, version: directorVersion, directorName: platformStatus.directorName });
          },
          err => { }
          );
      },
      (err: any) => {
        this.connectedDeviceService.setWorking(false);
        console.error('getSysmanInfo() error: ', err);
        device.errorMessage = "Connection Failed";
        this.errorMessage = "Connection failed. Please check if this device is running on your network.";
      });
  }

  // add user entered device
  onClickAddDevice() {
    if (this.connectedDeviceService.isValidIPAddress(this.addDeviceAddress)) {
      this.showInvalidIPAddress = false;
      this.showAddDeviceModal = false;
      this.customDeviceService.addCustomDevice(this.addDeviceName, this.addDeviceAddress);
    }
    else
      this.showInvalidIPAddress = true;
  }

  onClickAddDeviceModal() {
    this.addDeviceAddress = "";
    this.addDeviceName = "";
    this.showAddDeviceModal = true;
  }

  onRefresh() {
    this.discoveredDevices = [];
    this.allDevices = [];
    this.discoService.refreshDiscovery();
  }

  onSortOrderChange(e: any) {
    this.sortOrder = e;
    this.sortBy(this.sortByField, this.sortOrder);
  }

  onSortByChange(e: any) {
    this.sortByField = e;
    this.sortBy(this.sortByField, this.sortOrder);
  }

  // keep track of ssdp directors found
  updateDirectors(address: string) {
    let isDirector = false;
    let findDirectorItems = this.directorsFound.filter(item => {
      return (item == address);
    });
    if (findDirectorItems.length > 0)
      isDirector = true;

    if (isDirector) {
      // update sysman disco list with director info
      let findSysmanItems = this.allDevices.filter(item => {
        return (item.address == address);
      });
      if (findSysmanItems.length > 0)
        findSysmanItems[0].isDirector = true;
    }
  }

// direction: "asc" ascending or "desc" descending (default) 
  sortBy(field: string, direction: string) {

    let devices = [];
    // add custom devices to end of list
    if (this.customDevices.length > 0)
      devices = this.discoveredDevices.concat(this.customDevices);
    else
      devices = this.discoveredDevices;

    // sort IP address
    if (field == "ip") {
      devices = devices.sort((a, b) => {
        let aa = a.address.split(".");
        let bb = b.address.split(".");
        var resulta = aa[0] * 0x1000000 + aa[1] * 0x10000 + aa[2] * 0x100 + aa[3] * 1;
        var resultb = bb[0] * 0x1000000 + bb[1] * 0x10000 + bb[2] * 0x100 + bb[3] * 1;
        if (direction == "asc")
          return resultb - resulta;        
        else
          return resulta - resultb;
      });
    }
    else { // sort by name
        // check for broker host - pin to top
        let foundIndex: number = -1;
        let foundItems: Array<any> = [];
        // yank broker host out of array to sort
        while ((foundIndex = devices.findIndex(item => { return (item.address == this.brokerHost); })) > -1) {
          foundItems.push(devices.splice(foundIndex,1)[0]);
        }
        devices = devices.sort((a, b) => {
          let cmp = a.USN.toLowerCase().localeCompare(b.USN.toLowerCase());
          return ((direction == "asc") ? -cmp : cmp);
        });
        
        // add found item(s) back to top of list
        for (let i=foundItems.length-1; i>= 0; i--)
          devices.splice(0,0,foundItems[i]);
    }
    this.allDevices = devices;
  }

}



// WEBPACK FOOTER //
// ./~/@c4/sysman/src/app/sysman-sddp-discovery/sysman-sddp-discovery.component.ts